import { EVENT_STATUS } from "../eventStatus";
import { SALE_STATUS } from "../saleStatus";
import { SHIPMENT_STATUS } from "../shipmentStatus";

export const STATUS = {
  NO_LABEL: "none",
  ...SALE_STATUS,
  ...SHIPMENT_STATUS,
  ...EVENT_STATUS,
} as const;
